import { Component, Input, OnInit } from '@angular/core';

import { IconFontType } from '../../icon-font/icon-font-type.enum';
import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownInstrumentationEvents } from '../../instrumentation/instrumentation.service';
import { ContextMenuItem } from '../../models/context-menu-item.model';
import { CapabilitiesService } from '../../shared-context/capabilities.service';
import { DropdownMenu } from '../dropdown-menu/dropdown-menu.component';
import { MenuSelectItemEvent } from '../menu/menu-select-item.model';

import './split-button.component.css';

export interface SplitButtonModel {
    id: string;
    area: string;
    primaryAction: SplitButtonPrimaryAction;
    secondaryActions: Array<ContextMenuItem>;
    dropdownAriaLabel: string;
    dropdownTooltip: string;
    dropdownAriaDescription?: string;
}

export interface SplitButtonPrimaryAction {
    title: string;
    icon?: IconFontType;
    iconCssClass?: string;
    executeAction(): void;
    ariaLabel: string;
    ariaDescription?: string;
}

@Component({
    selector: 'ohp-split-button',
    templateUrl: './split-button.component.html'
})
export class SplitButtonComponent implements OnInit {

    @Input() public buttonModel: SplitButtonModel;

    @Input() public mobileMenu: boolean;

    public dropdownMenuModel: DropdownMenu<ContextMenuItem>;

    public fluentRefresh: boolean;

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly instrumentationService: InstrumentationService
    ) {
    }

    public ngOnInit() {
        this.fluentRefresh = this.capabilitiesService.capabilities.fluentRefresh;
        this.dropdownMenuModel = {
            id: `${this.buttonModel.id}-split-button-menu`,
            items: this.buttonModel.secondaryActions,
            rightAligned: true,
            customLogging: true,
            cssClass: 'split-button__menu',
            linkAriaLabel: this.buttonModel.dropdownAriaLabel,
            linkAriaDescription: this.buttonModel.dropdownAriaDescription,
            linkTooltip: this.buttonModel.dropdownTooltip,
            linkCssClass: `split-button__dropdown-button ${this.fluentRefresh ? 'generic-button--fluentvnext generic-button--fluentvnext--primary' : 'generic-button generic-button--fluent generic-button--fluent--primary ms-bgc-w-h ms-bgc-w-a ms-fcl-w ms-bgc-tp ms-fcl-tp-h ms-fcl-tp-a'}`
        };
    }

    public onToggleMenu(open: boolean): void {
        const action = open ? 'Open' : 'Close';
        const params: InstrumentationParams = {};
        params[InstrumentationParam.RenderSize] = this.buttonModel.secondaryActions.length.toString();
        params[InstrumentationParam.Action] = action;

        this.instrumentationService.logClickEvent(KnownInstrumentationEvents.SplitButtonToggle, this.buttonModel.id, this.buttonModel.area, null, null, params);
    }

    public onSelectItem(event: MenuSelectItemEvent<ContextMenuItem>) {
        event.item.executeAction();
    }
}
